/*
 * Author: Ben Zhao
 * File Created: Tuesday, 25-06-24 02:15 pm
 * Last Modified: Wednesday, 25-06-25 06:44 pm, by Ben Zhao
 */

export const ReferralUser = ({
  bgColor,
  userColor,
  width,
  height
}: {
  bgColor?: string;
  userColor?: string;
  width?: string;
  height?: string;
}) => {
  return <svg width={width ?? '33'} height={height ?? '32'} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="ReferralUser" data-sentry-source-file="index.tsx">
      <g clip-path="url(#clip0_7038_17109)" data-sentry-element="g" data-sentry-source-file="index.tsx">
        <rect width="32" height="32" transform="translate(0.00585938)" fill={bgColor ?? '#3E4457'} data-sentry-element="rect" data-sentry-source-file="index.tsx" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.9997 21.0354C19.6747 21.0354 22.6538 18.0563 22.6538 14.3814C22.6538 10.7065 19.6747 7.72739 15.9997 7.72739C12.3248 7.72739 9.34571 10.7065 9.34571 14.3814C9.34571 18.0563 12.3248 21.0354 15.9997 21.0354ZM11.7497 23.6971C7.48208 23.6971 4.02246 27.1567 4.02246 31.4244V38.336H27.977V31.4244C27.977 27.1567 24.5174 23.6971 20.2497 23.6971H11.7497Z" fill={userColor ?? '#202630'} data-sentry-element="path" data-sentry-source-file="index.tsx" />
      </g>
      <defs data-sentry-element="defs" data-sentry-source-file="index.tsx">
        <clipPath id="clip0_7038_17109" data-sentry-element="clipPath" data-sentry-source-file="index.tsx">
          <rect width="32" height="32" fill="white" transform="translate(0.00585938)" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
        </clipPath>
      </defs>
    </svg>;
};